module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09K1RXDYX.889a4455.jpg";